export function percentageValueOf(performance) {
    return (performance < 0 ? "\u2212" : "+") + (Math.abs(performance) * 100).toFixed(1) + "%"
}